// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"418":"vue-slick-carousel","485":"vue"}[chunkId] + "." + {"418":"ac09eaba0cca35b67a9c","485":"c30ff72887d50d6d052e"}[chunkId] + ".js";
};